import { render, staticRenderFns } from "./Boat.vue?vue&type=template&id=3ff3d8e4&scoped=true&"
import script from "./Boat.vue?vue&type=script&lang=js&"
export * from "./Boat.vue?vue&type=script&lang=js&"
import style0 from "./Boat.vue?vue&type=style&index=0&id=3ff3d8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3d8e4",
  null
  
)

export default component.exports